import { render, staticRenderFns } from "./LockedModuleInfo.vue?vue&type=template&id=1fad7e64&scoped=true"
import script from "./LockedModuleInfo.vue?vue&type=script&lang=js"
export * from "./LockedModuleInfo.vue?vue&type=script&lang=js"
import style0 from "./LockedModuleInfo.vue?vue&type=style&index=0&id=1fad7e64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fad7e64",
  null
  
)

export default component.exports